import TemplateView from '../../../../../js/TemplateView'
import FeedsTableSortingMenu from './FeedsTableSortingMenu'
import {DEFAULT_SORTING} from '../../constants'

export default class AllFeedsTableHeader extends TemplateView {

    constructor({
        changeSorting,
    }) {
        super()

        this.state = {
            sorting: DEFAULT_SORTING,
        }

        this.callbacks = {
            changeSorting,
        }

        this.onStatePropertyDeeplyChanged('sorting', sorting => this.sortingArea.setState({sorting}))
    }

    templateHtml() {
        return `<div class='header allFeeds'>
                    <div class='feedNameColumn'/>
                    <div class='calendarDetailsColumn'>
                        <%=calendarDetailsTitle%>
                    </div>
                    <div class='sharedUsersColumn'>
                        <%=sharedWithTitle%>
                    </div>
                    <div class='lastSyncColumn'>
                        <%=lastSyncTitle%>
                    </div>
                    <div class='actionsColumn'>
                        <%=actionsTitle%>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            calendarDetailsTitle: 'icalendar.page.table.column.details',
            sharedWithTitle: 'icalendar.page.table.columns.shared',
            lastSyncTitle: 'icalendar.page.table.columns.sync',
            actionsTitle: 'icalendar.page.table.columns.actions',
        }
    }

    afterRender() {
        this.sortingArea = new FeedsTableSortingMenu({
            changeSorting: this.callbacks.changeSorting,
            isLastSyncSortingIncluded: true,
        }).init(this.find('.feedNameColumn'))
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/AllFeedsTableHeader.js